import styles from "./leadjourneywrapper.module.css";
import ReminderComponent from "../ReminderComponent";
import InteractionComponent from "../InteractionComponent";
import LeadJourneyDetails from "./LeadJourneyDetails";
import LeadJourneySquare from "./LeadJourneySquare";
import { useGetLeadOwner } from "@/api/auth/useGetLeadOwner";
import { useGetLeadDetailsSquare } from "@/api/lead/useGetLeadDetailsSquare";

const LeadJourneyContainerWrapper = ({ leadID }) => {

  const leadOwner = useGetLeadOwner({leadID: leadID});
  const {leadDetails, refetch} = useGetLeadDetailsSquare({leadId: leadID});

  return (
    <div className={styles.wrapper}>
      <LeadJourneySquare leadDetails = {leadDetails} leadOwner = {leadOwner} onRefetch = {refetch}/>
      <LeadJourneyDetails leadOwner={leadOwner} leadID={leadID} />
      <div className="flex flex-col md:flex-row md:justify-between w-full gap-4 md:gap-0 mr-0 md:mr-5 px-2 sm:px-0">
        <ReminderComponent leadID={leadID} owner={leadOwner}/>
        <InteractionComponent leadID={leadID} owner={leadOwner}/>
      </div>
    </div>
  );
};

export default LeadJourneyContainerWrapper;
